import { render, staticRenderFns } from "./order-form-properties.vue?vue&type=template&id=3fe0b1e7"
import script from "./order-form-properties.vue?vue&type=script&lang=js"
export * from "./order-form-properties.vue?vue&type=script&lang=js"
import style0 from "./order-form-properties.vue?vue&type=style&index=0&id=3fe0b1e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports